"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Permission;
(function (Permission) {
    Permission["WRITE"] = "WRITE";
    Permission["READ"] = "READ";
})(Permission = exports.Permission || (exports.Permission = {}));
//# sourceMappingURL=Permission.js.map